import _ from 'lodash'

import { humanizeKey } from 'peach/helpers'

import MiniTable from '../MiniTable/MiniTable'

import { getTypeFromKey, sortObject } from './jsonHelpers'
import JsonList from './JsonList'
import JsonValue from './JsonValue'

const getWidth = (json) => {
  const keys = _.keys(json)
  const maxKeyLength = _.max(_.map(keys, (key) => key.length))
  return _.max([maxKeyLength * 8 + 20, 120])
}

const JsonTable = (props) => {
  const { json, title, compact, bare, humanizeKeys, ...rest } = props
  if (_.isEmpty(json)) {
    return (
      <MiniTable bare={bare} compact={compact} title={title} {...rest}>
        <JsonValue value={json} />
      </MiniTable>
    )
  }

  if (_.isArray(json) && _.isPlainObject(_.first(json))) {
    return (
      <>
        {_.map(json, (item, index) => (
          <JsonTable
            {...rest}
            compact
            json={item}
            key={`${item?.id}-${index}`}
            title={`[${index}]`}
          />
        ))}
      </>
    )
  }

  if (_.isArray(json) && !_.isObject(_.first(json))) {
    return <JsonList compact={compact} json={json} {...rest} />
  }

  if (_.isPlainObject(json)) {
    const { object } = json
    const width = getWidth(json)
    const sorted = sortObject(json)

    const pairs = _.toPairs(sorted)
    // converting to pairs becasue _.map breaks on objects with a length proeprty

    const rows = _.map(pairs, ([key, val]) => {
      const type = getTypeFromKey(key, val)
      const isObject = _.isObject(val) && !_.isEmpty(val)
      return (
        <MiniTable.Row key={key}>
          <MiniTable.Cell $top={isObject} width={`${width}px`}>
            <JsonValue
              type='key'
              value={humanizeKeys ? humanizeKey(key) : key}
              {...rest}
            />
          </MiniTable.Cell>
          {isObject ? (
            <JsonTable {...rest} compact json={val} title={humanizeKey(key)} />
          ) : (
            <JsonValue
              jsonKey={key}
              object={object}
              type={type}
              value={val}
              {...rest}
            />
          )}
        </MiniTable.Row>
      )
    })

    return (
      <MiniTable bare={bare} compact={compact} title={title}>
        {rows}
      </MiniTable>
    )
  }

  return <JsonValue value={json} />
}

export default JsonTable
